import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { PresentationContainer } from '@Components/index';
import { useAppDispatch } from '@Hooks/index';
import { useGetUserInfoMutation } from '@Store/api/userApiSlice';
import { userInfoActions } from '@Store/slices/userInfoSlice';
import { ResignationRequestApprove } from '@Features/EmployeeSelfService/requests/ResignationRequests';
import { useGetResignationRequestFormQuery } from '@Features/EmployeeSelfService/requests/ResignationRequests/store/api/resignationRequestApiSlice';

const ResignationRequestApproveForm: React.FC = () => {
  const { taskId, requestId } = useParams<{
    taskId: string;
    requestId: string;
  }>();
  const dispatch = useAppDispatch();

  const { data, isSuccess } = useGetResignationRequestFormQuery(requestId!);
  const [getUser] = useGetUserInfoMutation();

  useEffect(() => {
    if (data?.empNumber) {
      getUser({ empNo: data.empNumber })
        .unwrap()
        .then((user) => {
          dispatch(userInfoActions.setCreatedUserRequest(user));
        });
    }
  }, [data?.empNumber]);

  if (!isSuccess || !data) {
    return null;
  }

  return (
    <PresentationContainer fullHeight>
      <ResignationRequestApprove taskId={taskId!} formData={data} />
    </PresentationContainer>
  );
};

export default ResignationRequestApproveForm;
